import { render, staticRenderFns } from "./IQCHome.vue?vue&type=template&id=75d170f0&scoped=true"
import script from "./IQCHome.vue?vue&type=script&lang=js"
export * from "./IQCHome.vue?vue&type=script&lang=js"
import style0 from "./IQCHome.vue?vue&type=style&index=0&id=75d170f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d170f0",
  null
  
)

export default component.exports